import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BootstrapRoot from './BootstrapRoot';

// Evitar que el navegador restaure el scroll al cambiar de ruta (lo controlamos con ScrollToTop)
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BootstrapRoot />
  </React.StrictMode>
);